import { ReactNode, useCallback } from 'react';
import { Link as ReactRouterLink, LinkProps, useLocation } from 'react-router';

type LinkWithGlobalFilterProps = LinkProps & {
  forwardSearch?: boolean;
  children?: ReactNode;
  className?: string;
};

export default function Link({
  forwardSearch,
  children,
  className,
  to,
  ...linkProps
}: LinkWithGlobalFilterProps) {
  const location = useLocation();

  const constructToPath = useCallback(() => {
    if (forwardSearch) {
      if (typeof to === 'object' && to.search) {
        return to;
      }

      const toPath = typeof to === 'object' ? to.pathname : to;
      const hasQueryParams = toPath?.includes('?');

      const searchParams = hasQueryParams
        ? location.search.replace('?', '&')
        : location.search;

      return typeof to === 'object'
        ? { ...to, search: searchParams }
        : `${toPath}${searchParams}`;
    }

    return to;
  }, [forwardSearch, location.search, to]);

  return (
    <ReactRouterLink
      {...linkProps}
      className={className}
      to={constructToPath()}>
      {children}
    </ReactRouterLink>
  );
}
